export default __webpack_public_path__ + "static/benefits-dad682ee7fac0ebed0415925da5d198d.webp";